import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=7c4ed22e&scoped=true&"
import script from "./orderList.vue?vue&type=script&lang=js&"
export * from "./orderList.vue?vue&type=script&lang=js&"
import style0 from "./orderList.vue?vue&type=style&index=0&lang=less&"
import style1 from "./orderList.vue?vue&type=style&index=1&id=7c4ed22e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4ed22e",
  null
  
)

export default component.exports